<app-container type="dark" class="p-2">
	<p class="font-bold">{{ lenderName }}</p>
	<div class="grid grid-cols-2 gap-2 mt-2">
		<app-dropdown
			(onSelect)="setPercentageOfInterestType($event)"
			[ngModel]="percentageOfInterestTypeLabel"
			label="Percentage of Interest"
			[itemGroups]="[{ items: percentageOfInterestOptions }]"
		></app-dropdown>
		<app-input
			class="col-span-1"
			[(ngModel)]="percentageOfInterest"
			label="Share"
			(debounce)="updatePercentageOfInterestDetails()"
		></app-input>
	</div>
</app-container>
